import { render, staticRenderFns } from "./PositionOrSector.vue?vue&type=template&id=21c77546&scoped=true"
import script from "./PositionOrSector.vue?vue&type=script&lang=js"
export * from "./PositionOrSector.vue?vue&type=script&lang=js"
import style0 from "./PositionOrSector.vue?vue&type=style&index=0&id=21c77546&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21c77546",
  null
  
)

export default component.exports